var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<h1>\nMODULO DI TEST 2\n</h1>\n<button ng-click=\"moduloCtrl.incrStorage()\">+</button>\n<div>{{moduloCtrl.storage.conta}}</div>";
var id1="teststoragecommunications2.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;